"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageWithTitle = void 0;
var tslib_1 = require("tslib");
var pdfTheme_1 = require("../pdfTheme");
var ImageComponent_1 = require("./ImageComponent");
var fontSize = 14;
var ImageWithTitle = /** @class */ (function () {
    function ImageWithTitle(imageTitle, imageReference, opts) {
        if (opts === void 0) { opts = {}; }
        var _a, _b, _c;
        this.imageTitle = imageTitle;
        this.imageReference = imageReference;
        this.nodes = [];
        var defaultOptions = { width: pdfTheme_1.pdfTheme.page.width, height: pdfTheme_1.pdfTheme.page.height };
        //TODO: clean up pagebreaking logic. we do this here because elsewhere the titlebar is responsible for pagebreaking
        // and we only have a titlebar sometimes
        var pageBreak = (opts.pageBreak === 'none' || opts.sectionTitle) ? undefined : (_a = opts.pageBreak) !== null && _a !== void 0 ? _a : defaultOptions.pageBreak;
        this.options = {
            width: (_b = opts.width) !== null && _b !== void 0 ? _b : defaultOptions.width,
            sectionTitle: opts.sectionTitle,
            height: (_c = opts.height) !== null && _c !== void 0 ? _c : defaultOptions.height,
            pageBreak: pageBreak
        };
        if (this.options.sectionTitle) {
            this.nodes.push(this.options.sectionTitle);
        }
        var headersHeight = (this.options.sectionTitle ? this.options.sectionTitle.height : 0) + fontSize * pdfTheme_1.MAGIC_SCALING_NUMBER;
        this.imageComponent = new ImageComponent_1.ImageComponent(this.imageReference, this.options.width, this.options.height - headersHeight);
        this.nodes.push(this.imageComponent);
    }
    ImageWithTitle.prototype.exportContent = function () {
        return {
            unbreakable: true,
            margin: [0, 0],
            alignment: 'center',
            pageBreak: this.options.pageBreak,
            stack: tslib_1.__spreadArray(tslib_1.__spreadArray([], (this.options.sectionTitle ? [this.options.sectionTitle.exportContent()] : []), true), [
                {
                    text: this.imageTitle,
                    style: ['imageTitle']
                },
                this.imageComponent.exportContent()
            ], false)
        };
    };
    ImageWithTitle.prototype.exportStyles = function () {
        return {
            imageTitle: {
                fontSize: fontSize,
                alignment: 'center',
                color: pdfTheme_1.pdfTheme.font.color.dark
            }
        };
    };
    return ImageWithTitle;
}());
exports.ImageWithTitle = ImageWithTitle;
//# sourceMappingURL=ImageWithTitle.js.map